import React, {Component} from "react";
import "./InstancesListViewRow.css"
import Api from "../../api/Api";
import Authentication from "../../authentication/Authentication";
import moment from "moment/moment";

export default class InstancesListViewRow extends Component {


    constructor(props) {
        super(props);

        this.state = {

            dashboardStatus: this.props.instance.status
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.checkForRunningDashboard(this.props.instance.domain);
        this.pisaasDashboardStatusInterval = setInterval(this.pisaasDashboardStatusRefresh, 10000);
    }

    pisaasDashboardStatusRefresh = () => {
        const api = new Api();
        const currentTrypiPackageId = 8
        const instanceType = this.props.instance.package_id === currentTrypiPackageId ? "trypi" : "pisaas";
        const trypiUrl = instanceType === "trypi" ? this.props.instance["trypi_url"] : null;
        api.checkForRunningDashboard(this.setDashboardStatus, this.setDashboardStatus, this.props.instance.domain, instanceType, trypiUrl);
    }

    componentWillUnmount() {
        if (this.pisaasDashboardStatusInterval) {
            clearInterval(this.pisaasDashboardStatusInterval);
        }
    };

    checkForRunningDashboard = (domain) => {
        const api = new Api();
        const currentTrypiPackageId = 8
        const instanceType = this.props.instance.package_id === currentTrypiPackageId ? "trypi" : "pisaas";
        const trypiUrl = instanceType === "trypi" ? this.props.instance["trypi_url"] : null;
        api.checkForRunningDashboard(this.setDashboardStatus, this.setDashboardStatus, domain, instanceType, trypiUrl);
    }

    setDashboardStatus = (res) => {
        if (res.data === "true") {
            this.setState({
                dashboardStatus: "running"
            })
        } else {
            this.setState({
                dashboardStatus: this.props.instance.status
            })
        }
    }

    formatDate(date) {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("MMMM Do YYYY");
        }
        return "";
    };


    formatTime(date) {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("HH:mm:ss")
        }
        return "";
    };

    getLocaleTime = () => {
        const databaseTime = new Date(this.props.instance.current_time_utc).getTime();
        const signupDate = new Date(this.props.instance.signup_startdate).getTime();
        const currentLocaleDate = new Date().getTime();
        const UTCLocaleDifference = Math.round((currentLocaleDate - databaseTime) / 100000) * 100000;
        const momentDate = moment(signupDate + UTCLocaleDifference)
        momentDate.format("MMMM Do YYYY HH:mm:ss")
        return momentDate
    }

    render() {
        const localTime = this.getLocaleTime()
        return (
            <>
                <tbody>
                <tr className={"instances-table-row"} data-testid="instances.table.row">
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.type">{this.props.instance.package_id === 8 || this.props.instance.trypi_url ? "Trypi" : "Pisaas"}</th>
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.domain">{this.props.instance.domain}</th>
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.email">{this.props.instance.email}</th>
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.startDate">{this.formatDate(localTime)} {this.formatTime(localTime)}</th>
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.URL">{this.props.instance.package_id === 8 ? this.props.instance.trypi_url ? `https://${this.props.instance["trypi_url"]}` : "Pending" : this.props.instance.url}</th>
                    <th className={"instances-table-cell"} data-testid="instances.table.cell.status">{this.state.dashboardStatus}</th>
                </tr>
                </tbody>
            </>
        );
    }
}

